import styles from "./MetricCell.module.scss";
import { formatMetric } from "../../utils/formatters";
import { METRIC_TYPES, type HeaderKey } from "../../constants/metrics";
import type {
  MappedProduct,
  MappedStuck,
  MappedArticleData,
} from "../../types";

interface MetricCellProps {
  item: MappedProduct | MappedStuck | MappedArticleData;
  columnKey: HeaderKey;
}

export function MetricCell({ item, columnKey }: MetricCellProps) {
  const { main, suffix, extraMain, extraSuffix } = formatMetric(
    item[columnKey],
    METRIC_TYPES[columnKey],
    columnKey === "ordersAmount" ? item.ordersCount : undefined,
  );

  return (
    <>
      <span className={styles.mainValue}>{main}</span>
      {suffix && <span className={styles.suffixValue}>{suffix}</span>}
      {extraMain && <span className={styles.mainValue}>{extraMain}</span>}
      {extraSuffix && <span className={styles.suffixValue}>{extraSuffix}</span>}
    </>
  );
}
